import ConnectionsActions from '../actions/ConnectionsCRUDActions';
import Actions from '../actions/actions';
import { setBusy, setUnBusy, update } from './common/commonReducers';
import { Connections } from '../interfaces/connections';
import { Pagination } from '../store-interfaces';
import ConnectionModel from '../model/ConnectionModel';
import { unionBy } from 'lodash';

const initialState: Connections = {
  busy: false,
  entities: [],
  widgetConnections: null,
  widgetGoogleConnections: [],
  widgetFacebookAudienceConnections: [],
  pagination: {} as Pagination,
};

export default function forms(
  state: Connections = initialState,
  action,
): Connections {
  switch (action.type) {
    case ConnectionsActions.busyAction:
      return setBusy(state);
    case ConnectionsActions.unbusyAction:
      return setUnBusy(state);
    case ConnectionsActions.updateAction:
      return update(state, action);
    case ConnectionsActions.retrievedAction: {
      const { entity: newConnection } = action;
      const { entities } = state;

      const connectionIndex = entities?.findIndex(
        connection =>
          connection.id === newConnection.id &&
          connection.connectionType === newConnection.connectionType,
      );
      let updatedEntities: ConnectionModel[];

      if (connectionIndex !== -1) {
        updatedEntities = [
          ...entities.slice(0, connectionIndex),
          newConnection,
          ...entities.slice(connectionIndex + 1),
        ];
      } else {
        updatedEntities = [...entities, newConnection];
      }
      return {
        ...state,
        busy: false,
        entities: updatedEntities,
      };
    }

    case ConnectionsActions.deleteLocalAction: {
      const { connectionType, id: connectionId } =
        action.entity as ConnectionModel;
      const entities = state.entities.filter(
        c => c.id !== connectionId || c.connectionType !== connectionType,
      );
      return {
        ...state,
        busy: false,
        entities,
      };
    }
    case Actions.UNBUSY:
      return setUnBusy(state);
    case ConnectionsActions.retrievedAllAction: {
      const { connections, pagination } = action.entities;
      const filteredEntities = state.entities.filter(
        entity => !connections.find(connection => connection.id === entity.id),
      );

      return {
        ...state,
        busy: false,
        entities: unionBy(filteredEntities, connections),
        pagination,
      };
    }
    case ConnectionsActions.retrievedAllByType: {
      const { connectionType } = action;

      const { connections, pagination } = action.entities;
      const filteredEntities = !connections.length
        ? state.entities.filter(c => c.integrationType !== connectionType)
        : state.entities.filter(
            entity =>
              !connections.find(connection => connection.id === entity.id),
          );

      return {
        ...state,
        busy: false,
        entities: unionBy(filteredEntities, connections),
        pagination,
      };
    }

    case ConnectionsActions.retrieveWidgetConnectionsAction: {
      const { connections } = action;

      return {
        ...state,
        busy: false,
        widgetConnections: connections,
      };
    }

    case ConnectionsActions.retrievedWidgetGoogleConnections: {
      const { connections } = action;

      return {
        ...state,
        busy: false,
        widgetGoogleConnections: connections,
      };
    }

    case ConnectionsActions.retrievedWidgetFacebookAudienceConnections: {
      const { connections } = action;

      return {
        ...state,
        busy: false,
        widgetFacebookAudienceConnections: connections,
      };
    }

    case ConnectionsActions.updateVariableOptionsAction: {
      const { options } = action;

      return {
        ...state,
      };
    }

    case Actions.RESET:
    case ConnectionsActions.invalidateAllAction: {
      return initialState;
    }
    default:
      return state;
  }
}
